










































































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  CountEmployeeDocumentApprovalRequest,
  Employee,
  GetTarfRequestStatusesResponse,
  Message,
  RoomStatusCount,
  RoomStatusCounts,
  StaffSurveyCategory,
  TarfStatusDetail,
} from "@/api";
import NavigationItem from "@/components/NavigationItem.vue";
import auth from "@/auth";
import FiveStarMomentButton from "@/components/five_star/FiveStarMomentButton.vue";
import * as roleUtils from "@/common/role_utils";
import _ from "lodash";
import statusId from "@/tool/tarfStatus";
import ExpensionNavigationItem from "./ExpansionNavigationItem.vue";
import moment from "moment";
import {
  socket,
  connect,
  updateType,
  NotificationType,
} from "@/tool/socket.io";
import { isSuperAdmin } from "@/common/role_utils";

type subItem = {
  icon: string;
  label: string;
  rootPath: string;
  primaryNotice?: string;
  secondaryNotice?: string;
  if: boolean;
  // eslint-disable-next-line
  primaryFilter?: (items: any) => any;
  // eslint-disable-next-line
  secondaryFilter?: (items: any) => any;
  noticeColor?: string;
  noticeColorSecondary?: string;
};

@Component({
  components: { FiveStarMomentButton, NavigationItem, ExpensionNavigationItem },
})
export default class NavigationRail extends Vue {
  mini = false;
  get isSelfLead() {
    return roleUtils.checkSelfLead();
  }

  get isGuardianAngel() {
    return roleUtils.checkGuardianAngel();
  }
  get guardianAngelsSubItems(): subItem[] {
    return [
      {
        icon: "mdi-minus-thick",
        label: "Overview",
        rootPath: "/guardian-angel/overview",
        if: true,
      },
      {
        icon: "mdi-minus-thick",
        label: "Report Summary",
        rootPath: "/guardian-angel/summary",
        if: true,
      },
      {
        icon: "mdi-minus-thick",
        label: "Assignments",
        rootPath: "/guardian-angel/assignments",
        if: true,
      },
      {
        icon: "mdi-minus-thick",
        label: "Tracking",
        rootPath: "/guardian-angel/tracking",
        if: true,
      },
      {
        icon: "mdi-minus-thick",
        label: "Form",
        rootPath: "/guardian-angel/form",
        if: roleUtils.checkSelfRole("owner"),
      },
    ];
  }
  get surveySubItems(): subItem[] {
    return [
      {
        icon: "mdi-minus-thick",
        label: "Overview",
        rootPath: "/survey/overview",
        if: true,
      },
      {
        icon: "mdi-minus-thick",
        label: "Report Summary",
        rootPath: "/survey/summary",
        if: true,
      },
      {
        icon: "mdi-minus-thick",
        label: "Admission Form",
        rootPath: "/survey/admission/form",
        if: roleUtils.checkSelfRole("owner"),
      },
      {
        icon: "mdi-minus-thick",
        label: "Discharge Form",
        rootPath: "/survey/discharge/form",
        if: roleUtils.checkSelfRole("owner"),
      },
      {
        icon: "mdi-minus-thick",
        label: "Satisfaction Form",
        rootPath: "/survey/satisfaction/form",
        if: roleUtils.checkSelfRole("owner"),
      },
    ];
  }

  calendarSubItems: subItem[] = [
    {
      icon: "mdi-minus-thick",
      label: "Staff Calendar",
      rootPath: "/calendar",
      primaryNotice: "calendar/count",
      if: true,
      noticeColor: "primary",
    },
    {
      icon: "mdi-minus-thick",
      label: "Patient Calendar",
      rootPath: "/patient-calendar",
      primaryNotice: "patientCalendar/count",
      if: true,
      noticeColor: "primary",
    },
  ];
  get documentSubItems(): subItem[] {
    return [
      {
        icon: "mdi-domain",
        label: this.isRole("owner")
          ? "Company Documents"
          : "Department Documents",
        rootPath: "/company-document",
        if: this.companyDocumentAccess,
      },
      {
        icon: "mdi-file-document",
        label: "Employee Documents",
        rootPath: "/employee-document",
        if: !this.isSuperAdmin,
      },
      {
        icon: "mdi-file-document",
        label: "ED Approval",
        rootPath: "/document-approval",
        if: this.edApprovalAccess,
        primaryNotice: "employeeDocuments/employeeDocumentCount",
        primaryFilter: this.documentFilter,
        noticeColor: "primary",
      },
      {
        icon: "mdi-clipboard-file",
        label: "Time Adjustment Form",
        rootPath: this.formRoute,
        if: !this.isSuperAdmin,
        primaryNotice: "tarf/tarfStatus",
        primaryFilter: this.tarfStatusFilter,
        noticeColor: "primary",
      },
    ];
  }

  created() {
    this.connectSocket();
    if (this.$vuetify.breakpoint.smAndDown) {
      this.mini = true;
      this.$store.dispatch("toggleNavRail");
    }
    if (!isSuperAdmin()) this.fetchStatusesAndCount();

    if (socket) {
      socket.on("/message", (msg: Message) => {
        const from = this.$route.params.id;
        const fetchChat =
          (from == msg.from.id.toString() ||
            roleUtils.selfData().id == msg.from.id ||
            from == msg.group?.toString()) &&
          this.$route.fullPath.includes("chat");
        if (fetchChat) {
          this.$store.dispatch("chat/addChat", msg);
        }
        this.$store.dispatch("chat/fetchChatList");
      });
      socket.on("/notification", (msg: NotificationType) => {
        updateType(
          msg.type,
          this.routeTarfStatus,
          this.documentId,
          this.status,
          msg.submitter,
        );
      });
    }
  }

  connectSocket() {
    if (this.selfInfo && this.selfInfo.firstName) {
      connect(
        this.selfInfo.id,
        this.selfInfo.firstName,
        this.selfInfo.companyId,
      );
    }
  }

  get selfInfo(): Employee {
    const emp = this.$store.getters["getCurrentEmployeeSelf"] as Employee;
    return emp;
  }

  isRole(role: string) {
    return roleUtils.checkSelfRole(role.toLowerCase());
  }

  get routeTarfStatus() {
    const stat = this.$route.params.status;
    if (stat) {
      if (stat === "new") return statusId.new;
      if (stat === "excused") return statusId.excused;
      if (stat === "unexcused") return statusId.unexcused;
      if (stat === "processed") return statusId.processed;
      if (stat === "denied") return statusId.deny;
      if (stat === "resubmit") return statusId.resubmit;
      return -1;
    }
    if (this.$route.path.includes("/form/employee")) return 6;
    return -1;
  }

  get documentId() {
    const id = this.$route.params.documentId;
    if (id) {
      return Number(id);
    }
    return -1;
  }

  get status() {
    const id = this.$route.params.status;
    if (id) {
      return Number(id);
    }
    return -1;
  }

  async fetchStatusesAndCount() {
    const categories = this.$store.dispatch("staffSurvey/getCategories");
    const tarfStatus = this.$store.dispatch("tarf/fetchTarfStatuses", {
      force: false,
      toFetch: this.routeTarfStatus,
    });

    const eventCount = this.$store.dispatch(
      "EventMetricAdmin/fetchEventCount",
      {
        eventId: -1,
        date: moment()
          .local()
          .format("YYYY-MM-DD"),
      },
    );

    const calEventCount = await this.$store.dispatch("calendar/fetchCount");

    // fetch a patient event count
    const pateintCalEventCount = await this.$store.dispatch(
      "patientCalendar/fetchCount",
    );

    const unreadMessageCount = await this.$store.dispatch(
      "chat/fetchUnreadMessageCount",
    );

    const roomStatusCount = await this.$store.dispatch(
      "room/fetchRoomsStatusCount",
    );

    const startDate = moment()
      .startOf("week")
      .format("YYYY-MM-DD");
    const endDate = moment()
      .endOf("week")
      .format("YYYY-MM-DD");

    const gaInspectionCount = await this.$store.dispatch(
      "inspection/fetchInspectionCount",
      { beginAt: startDate, endAt: endDate },
    );

    const handbookCount = await this.$store.dispatch(
      "handbook/fetchHandbookCount",
    );

    const suggestionCount = await this.$store.dispatch(
      "suggestion/fetchSuggestionCount",
    );

    const admissionCount = await this.$store.dispatch(
      "survey/fetchAdmissionSurveyCounts",
    );

    const dischargeCount = await this.$store.dispatch(
      "survey/fetchDischargeSurveyCounts",
    );

    if (this.isRole("owner")) {
      const documentCount = this.$store.dispatch(
        "employeeDocuments/getEmployeeDocumentCount",
      );
      await Promise.all([
        categories,
        tarfStatus,
        eventCount,
        documentCount,
        calEventCount,
        unreadMessageCount,
        pateintCalEventCount,
        roomStatusCount,
        gaInspectionCount,
        handbookCount,
        suggestionCount,
        admissionCount,
        dischargeCount,
      ]);
    } else {
      await Promise.all([
        categories,
        tarfStatus,
        eventCount,
        calEventCount,
        unreadMessageCount,
        roomStatusCount,
        gaInspectionCount,
        handbookCount,
        suggestionCount,
        admissionCount,
        dischargeCount,
      ]);
    }
  }

  tarfStatusFilter(items: GetTarfRequestStatusesResponse) {
    const newStatus = _.find(
      items?.statuses ?? [],
      (status: TarfStatusDetail) => status.id == 0,
    );
    if (newStatus) return newStatus?.count;
    else return null;
  }

  documentFilter(count: CountEmployeeDocumentApprovalRequest[]) {
    return count?.find(
      (doc: CountEmployeeDocumentApprovalRequest) => doc.id === 0,
    );
  }

  get staffSurveySubItems(): subItem[] {
    const categories = this.$store.getters["staffSurvey/categories"] as Array<
      StaffSurveyCategory
    >;
    const staticItems: subItem[] = [
      {
        icon: "mdi-minus-thick",
        label: "Overview",
        rootPath: "/staff-survey/overview",
        if: true,
      },
      {
        icon: "mdi-minus-thick",
        label: "Report Summary",
        rootPath: "/staff-survey/summary",
        if: true,
      },
    ];
    const dynamicItems: subItem[] = (categories ?? []).map(
      (category: StaffSurveyCategory) => ({
        icon: "mdi-minus-thick",
        label: category.name + " Form",
        rootPath: `/staff-survey/${category.slug}/form`,
        if: roleUtils.checkSelfRole("owner"),
      }),
    );
    return _.uniqBy([...staticItems, ...dynamicItems], item => item.label);
  }

  get isAdmin() {
    return roleUtils.isAdmin();
  }

  get isSuperAdmin() {
    return this.$store.getters["isSuperAdmin"];
  }

  get formRoute() {
    if (this.isAdmin || this.isSuperAdmin) {
      return "/form/supervisor";
    } else {
      return "/form/employee";
    }
  }

  get expenseReportPath() {
    if (this.isRole("owner")) return "/expense-report/owner";
    else return "/expense-report/admin";
  }

  get isOpen() {
    const navigationRailIsOpen = this.$store.state.navigationRailIsOpen;
    this.mini = !navigationRailIsOpen;
    return navigationRailIsOpen;
  }

  set isOpen(visible) {
    this.$store.dispatch("setNavRailVisibility", visible);
  }

  currentRoute() {
    return this.$route.path;
  }

  get companyRoute() {
    if (this.$route.path.includes("/company-list")) {
      return this.$route.path;
    }
    return "/company-list";
  }

  async logout() {
    await auth.logout();
    location.reload();
  }

  roomStatusCleanFilter(items: RoomStatusCounts) {
    return items?.find(
      (status: RoomStatusCount) => status.status.toLowerCase() == "clean",
    );
  }

  roomStatusDirtyFilter(items: RoomStatusCounts) {
    return items?.find(
      (status: RoomStatusCount) => status.status.toLowerCase() == "dirty",
    );
  }

  get companyDocumentAccess() {
    return !this.isRole("employee") && !this.isSuperAdmin;
  }

  get edApprovalAccess() {
    return this.isRole("owner");
  }
}
